import React from 'react';
import { get } from 'lodash';
import moment from 'moment';
import { Loading, Text, Column, FlexContainer, Row } from '../../../../../../components/common';
import GetOrderById from '../../../../../../components/graphql/getOrderById';
import { DrawerTitle } from '../DrawerTitle';
import CallAndChatHistory from './components/CallAndChatHistory';
import { getIconTypeClient } from './variants/headerInfoShared';

const styleCardNew = {
    backgroundColor: 'white',
    width: '100%',
    borderRadius: 8,
    marginBottom: 20,
};

const styleCardDeliveryInfo = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    padding: '8px 16px',
    height: 'auto'
};

const getElementsCardDeliveryNew = (data) => {
    return [
        {
            key: 'Cliente',
            value: `${get(data, 'customer.firstName')} ${get(data, 'customer.lastName')}`,
            active: true
        },
        {
            key: 'Fecha',
            value: moment(get(data, 'logisticsInfo.shippingETA'), 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY'),
            active: true
        },
        {
            key: 'Promesa',
            value: `${get(data, 'logisticsInfo.shippingETA', '').split(' ')[1]}-${get(data, 'logisticsInfo.shippingETAend', '').split(' ')[1]}`,
        },
        {
            key: 'Contacto',
            value: get(data, 'contactPreference', '-'),
            active: true
        },
        {
            key: 'Picker',
            value: get(data, 'assignInfo.picker.firstName', '-') + ' ' + get(data, 'assignInfo.picker.lastName', '-'),
            active: true
        },
        {
            key: 'Entrega',
            value: get(data, 'logisticsInfo.selectedSla', '-'),
            active: true
        }
    ];
};

const AuditHeaderInfo = ({
    orderId,
    dataParent,
    weightValidationCart
}) => {
    return (
        <FlexContainer pT={20}>
            <GetOrderById variables={{ filters: [{ field: 'idOrder', value: orderId }] }}>
                {({ data, loading }) => {
                    return (
                        <Loading loading={loading}>
                            <FlexContainer width='100%' justify='space-between' gap={15} height="220px" padding={'0 0 0 12px '}>
                                <Column style={{ ...styleCardNew, alignItems: 'stretch' }}>
                                    <Row justify='space-between' align='center' maxHeight="50px">
                                        <DrawerTitle orderId={orderId} icon={getIconTypeClient(data, 20, 20)} />
                                    </Row>
                                    <div style={styleCardDeliveryInfo}>
                                        {getElementsCardDeliveryNew(data).map(({ key, value }) => {
                                            return (
                                                <span style={{ margin: '8px 0' }} key={key}>
                                                    <Text text={key} size={14} strong />:

                                                    <Text text={" "+ value} size={14} />
                                                </span>
                                            );
                                        })}
                                    </div>
                                    {weightValidationCart && weightValidationCart}
                                </Column>
                                <Column style={{
                                    ...styleCardNew,
                                    backgroundColor: undefined,
                                    borderRadius: '0 0 12px 12px',
                                    width: 'max-content'
                                }}>
                                    <CallAndChatHistory
                                        isWhatsapp={get(dataParent, 'isWhatsapp', false)}
                                        orderId={orderId}
                                        picker={get(data, 'assignInfo.idUser', '-').split('@')[0]}
                                        client={`${get(data, 'customer.firstName')} ${get(data, 'customer.lastName')}`}
                                    />
                                </Column>
                            </FlexContainer>
                        </Loading>
                    );
                }}
            </GetOrderById>
        </FlexContainer>
    );
};

export default React.memo(AuditHeaderInfo);
